import { IGameAssignmentContext } from './gameAssignmentContext';

export enum GameAssignmentActionTypes {
	SET_GAMES_FOR_ASSIGN = 'SET_GAMES_FOR_ASSIGN',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	CHANGE_SEARCH_STRING_FOR_ALL_CUSTOMERS = 'CHANGE_SEARCH_STRING_FOR_ALL_CUSTOMERS',
	CHANGE_SEARCH_STRING_FOR_RESTAURANTS = 'CHANGE_SEARCH_STRING_FOR_RESTAURANTS',
	CHANGE_SEARCH_STRING_FOR_GAMES = 'CHANGE_SEARCH_STRING_FOR_GAMES',
	SET_CATEGORY = 'SET_CATEGORY',
	SET_DEVELOPER = 'SET_DEVELOPER',
	TOGGLE_UNASSIGNED_GAMES = 'TOGGLE_UNASSIGNED_GAMES',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_IDS_SELECTED_GAME = 'SET_IDS_SELECTED_GAME',
	CHANGE_ACTIVE_ITEM_TO_DISPLAY = 'CHANGE_ACTIVE_ITEM_TO_DISPLAY',
	SET_SHOW_BREADCRUMBS = 'SET_SHOW_BREADCRUMBS',
	SET_ALL_CUSTOMERS = 'SET_ALL_CUSTOMERS',
	SET_IDS_SELECTED_CUSTOMERS = 'SET_IDS_SELECTED_CUSTOMERS',
	SET_IDS_SELECTED_RESTAURANTS = 'SET_IDS_SELECTED_RESTAURANTS',
	SET_GAMES = 'SET_GAMES',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	RESET_CHANGES = 'RESET_CHANGES',
}

interface ISetGamesForAssign {
	type: GameAssignmentActionTypes.SET_GAMES_FOR_ASSIGN;
	payload: {
		gamesForAssign: IGameAssignmentContext['gamesForAssign'];
	};
}

interface IChangeSearchString {
	type: GameAssignmentActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IGameAssignmentContext['searchString'];
	};
}

interface IChangeSearchStringForAllCustomers {
	type: GameAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_ALL_CUSTOMERS;
	payload: {
		searchStringForAllCustomers: IGameAssignmentContext['searchStringForAllCustomers'];
	};
}

interface IChangeSearchStringForRestaurants {
	type: GameAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_RESTAURANTS;
	payload: {
		searchStringForRestaurants: IGameAssignmentContext['searchStringForRestaurants'];
	};
}

interface IChangeSearchStringForGames {
	type: GameAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_GAMES;
	payload: {
		searchStringForGames: IGameAssignmentContext['searchStringForGames'];
	};
}

interface ISetCategory {
	type: GameAssignmentActionTypes.SET_CATEGORY;
	payload: {
		selectedCategory: IGameAssignmentContext['selectedCategory'];
	};
}

interface ISetDeveloper {
	type: GameAssignmentActionTypes.SET_DEVELOPER;
	payload: {
		selectedDeveloper: IGameAssignmentContext['selectedDeveloper'];
	};
}

interface IToggleUnassignedGames {
	type: GameAssignmentActionTypes.TOGGLE_UNASSIGNED_GAMES;
}

interface IResetSelectedControls {
	type: GameAssignmentActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: GameAssignmentActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IGameAssignmentContext['sortBy'];
	};
}

interface ISetIDsSelectedGame {
	type: GameAssignmentActionTypes.SET_IDS_SELECTED_GAME;
	payload: {
		IDsSelectedGame: IGameAssignmentContext['IDsSelectedGame'];
	};
}

interface IChangeActiveItemToDisplay {
	type: GameAssignmentActionTypes.CHANGE_ACTIVE_ITEM_TO_DISPLAY;
	payload: {
		activeItemToDisplay: IGameAssignmentContext['activeItemToDisplay'];
	};
}

interface ISetShowBreadcrumbs {
	type: GameAssignmentActionTypes.SET_SHOW_BREADCRUMBS;
	payload: {
		isShowBreadcrumbs: IGameAssignmentContext['isShowBreadcrumbs'];
	};
}

interface ISetAllCustomers {
	type: GameAssignmentActionTypes.SET_ALL_CUSTOMERS;
	payload: {
		allCustomers: IGameAssignmentContext['allCustomers'];
	};
}

interface ISetIDsSelectedCustomers {
	type: GameAssignmentActionTypes.SET_IDS_SELECTED_CUSTOMERS;
	payload: {
		IDsSelectedCustomers: IGameAssignmentContext['IDsSelectedCustomers'];
		restaurants: IGameAssignmentContext['restaurants'];
		IDsSelectedRestaurants: IGameAssignmentContext['IDsSelectedRestaurants'];
		games: IGameAssignmentContext['games'];
	};
}

interface ISetIDsSelectedRestaurants {
	type: GameAssignmentActionTypes.SET_IDS_SELECTED_RESTAURANTS;
	payload: {
		IDsSelectedRestaurants: IGameAssignmentContext['IDsSelectedRestaurants'];
		games: IGameAssignmentContext['games'];
	};
}

interface ISetGames {
	type: GameAssignmentActionTypes.SET_GAMES;
	payload: {
		games: IGameAssignmentContext['games'];
		IDsSelectedGame: IGameAssignmentContext['IDsSelectedGame'];
	};
}

interface IChangeTypeOfModalWindow {
	type: GameAssignmentActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IGameAssignmentContext['typeOfModalWindow'];
	};
}

interface IChangeCurrentPage {
	type: GameAssignmentActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IGameAssignmentContext['currentPage'];
	};
}

interface IResetChanges {
	type: GameAssignmentActionTypes.RESET_CHANGES;
}

export type TGameAssignmentAction =
	| ISetGamesForAssign
	| IChangeSearchString
	| IChangeSearchStringForAllCustomers
	| IChangeSearchStringForRestaurants
	| IChangeSearchStringForGames
	| ISetCategory
	| ISetDeveloper
	| IToggleUnassignedGames
	| IResetSelectedControls
	| ISetSortBy
	| ISetIDsSelectedGame
	| IChangeActiveItemToDisplay
	| ISetShowBreadcrumbs
	| ISetAllCustomers
	| ISetIDsSelectedCustomers
	| ISetIDsSelectedRestaurants
	| ISetGames
	| IChangeTypeOfModalWindow
	| IChangeCurrentPage
	| IResetChanges;
